import React, { Component } from 'react';
import {connect} from 'react-redux';
import history from '../../../../history';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../modal/LoaderModal';
import { CONFIG,URL_AKM } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import {TableContainer,Paper} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class DownloadSoal extends Component{
    constructor(props) {
        super(props);
        this.state = {      
            listSoal:[], 
            listDetailSoal: [], 
            profil: {},   
            subProfil: {},       
            isFetching: false,
        }
    }
    
    async componentDidMount() {        
        this.setState({ isFetching: true });          
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)){
           
            console.log(this.props.location.state)
            if(this.props.location.state != undefined) { 
                const profil = this.props.location.state.profil, 
                    subProfil = this.props.location.state.subProfil;
                this.setState({ profil: profil, subProfil: subProfil})
                this.fetchExamSoal(subProfil.idSubProfilCbt);
            }
        }        
        this.setState({ isFetching: false });       
    }


    fetchExamSoal = async(id) => {
        this.setState({ isFetching: true, listSoal:[] });
        const result = await accountManagement.get(CONFIG.EXAM_SOAL_GET + id)
            .catch(function(error){
                console.log(error)
            });
        
        if (result) { 
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){  
                let arraySoal = result.data.data.map(data => {                   
                    if(data.tipeSoal === 'BNS' || data.tipeSoal === 'DRAG') {                        
                        this.fetchSoalDetail(data.idBankSoal);       
                    }
                    return {...data}
                });
                this.setState({ listSoal: arraySoal });
            }
            this.setState({ isFetching: false });
        }
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://s3edubucket.s3-ap-southeast-1.amazonaws.com/javascripts/MathJax-2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';
        
            if (window.opera) {
                script.innerHTML = config
            } else {
                script.text = config
            }
        
            script.addEventListener('load', function() {
                window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub], "");
            })
        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();      
        
        this.setState({ isFetching: false });     
    }


    renderSoal(){
        if(!__.isEmpty(this.state.listSoal)){
            return(
                <React.Fragment>
                    {this.state.listSoal.map((soal,i) => 
                    
                     <tr key={i}>
                        <td><p>{i+1}</p></td>
                        <td>
                            <tr>
                                Tipe Soal : {soal.tipeSoal} &nbsp;&nbsp;|| &nbsp;&nbsp;
                                {
                                    soal.mudahSulit ==1 ? 'Mudah' :
                                    soal.mudahSulit ==2 ? 'Sedang' :
                                    soal.mudahSulit ==3 ? 'Sulit' :
                                    soal.mudahSulit ==4 ? 'Hot' :
                                    '-'
                                }
                            </tr>
                            <tr>
                                <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                                
                            </tr>
                            <table className="table table-borderless">
                                <tbody>
                                    {soal.jawab1 !== null && <tr><td width="5">A.</td><td dangerouslySetInnerHTML={{__html: soal.jawab1}}></td></tr>}
                                    {soal.jawab2 !== null && <tr><td width="5">B.</td><td dangerouslySetInnerHTML={{__html: soal.jawab2}}></td></tr>}
                                    {soal.jawab3 !== null && <tr><td width="5">C.</td><td dangerouslySetInnerHTML={{__html: soal.jawab3}}></td></tr>}
                                    {soal.jawab4 !== null && <tr><td width="5">D.</td><td dangerouslySetInnerHTML={{__html: soal.jawab4}}></td></tr>}
                                    {soal.jawab5 !== null && <tr><td width="5">E.</td><td dangerouslySetInnerHTML={{__html: soal.jawab5}}></td></tr>} 
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    )}
                </React.Fragment>
            )
        }
    }




    render() {   
        const style = {
            margin: 0,
            top: 'auto',
            right: 'auto',
            bottom: 55,
            left: 'auto',
            position: 'fixed',
        };     
        return (  
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <TableContainer component={Paper}>                    
                    <table className="table">
                        <thead>
                        <tr>
                            <th width="2%">No</th>
                            <th>Pertanyaan</th>                                
                        </tr>
                        </thead>
                        <tbody>
                            {this.renderSoal()}
                        </tbody>
                    </table>
                </TableContainer>  
                <div>
                    <Fab style={style} onClick={() => this.handleBack()}
                    variant="extended"
                    size="small"
                    color="secondary"
                    aria-label="add"
                    ><ArrowBackIosIcon />back</Fab>                    
                </div>

            </div>
        );
    }

    handleBack() {
        history.push({
            pathname: '/akm',
            state: {profil: this.state.profil} 
        })
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(DownloadSoal); 